/* cf-unbuildable-guard.js - Click Fencing
 *
 * 2026-09-01 (later session) - THIS NO LONGER BLOCKS ANYTHING, AND NO LONGER SHOWS THE
 * CUSTOMER AN ERROR. It flags internally instead.
 *
 * Pete, 2026-09-01, after hitting it on a bag of grout and then on a raked post:
 *   "this error is ridiculous. also we should never have customer facing errors saying
 *    we can not make the order."
 *   "we can always call a customer to discuss altering their order if its not available"
 *   "always stock everything"
 *   "another stupid error message. we need to have none of these"
 *
 * WHAT IT USED TO DO, AND WHY THAT WAS WRONG. It took any quote line that still had no
 * variantId after cf-quote-truth.js had run, called it unbuildable, and then:
 *   - rendered a red "One part of this quote cannot be supplied" panel saying the quote
 *     "cannot be checked out as it stands";
 *   - added .cf-ub-blocked to Continue to Payment (opacity .5, pointer-events:none);
 *   - cancelled the click in the capture phase;
 *   - on the glass calculator, cancelled Add to Cart outright.
 *
 * The test was "no variantId", which is not the same question as "can we supply this".
 * It fired on 2 x Sika HES Class C Grout and on 1 x In-Ground Raked Post - a consumable
 * and a stocked post - and dead-ended a customer who was ready to pay, on the last screen
 * before payment. It had already been patched once for the same class of false positive
 * (the S&I "Turn-key Design and Installation Service" line, see isExempt below). A rule
 * that keeps needing exemptions to stop it refusing real orders is the wrong rule.
 *
 * WHY REMOVING THE BLOCK IS SAFE. cf-real-line-items.js already degrades correctly on its
 * own: any line it cannot resolve to a variant is left out of the real cart lines and its
 * value is carried in a single "Balance of quoted total" line whose Note names the missing
 * items ("Balance of quoted total - 2 x Sika HES Class C Grout"). So the customer is
 * charged the quoted total to the cent, and the order already tells the office exactly
 * which parts need picking by hand or checking. Nothing is lost by letting it through -
 * the order simply arrives, and we ring the customer if the design needs altering.
 *
 * WHAT IT DOES NOW.
 *   - Never cancels a click, never disables a button, never renders a customer-facing panel.
 *   - Removes any stale panel or blocked state left by a previously cached copy of itself.
 *   - Records what it noticed onto the CART, so it reaches the order and the office sees it:
 *       attribute  "Check With Customer" : "2 x Sika HES Class C Grout"
 *     appended by intercepting /cart/update.js, the same hook quote-review-si-addon.js uses,
 *     because that call is made once with the customer's details just before /checkout.
 *   - console.warn()s for us. That is a developer signal, not a customer signal.
 *
 * If a genuinely unbuildable size ever needs stopping again, stop it at the point of
 * DESIGN - in the calculator, where the customer can still change the number and fix it
 * themselves - never at the point of PAYMENT, where their only options are give up or
 * email us.
 */
(function () {
  'use strict';
  if (window.__cfUnbuildableInstalled) return;
  window.__cfUnbuildableInstalled = true;

  var CALCS = ['ullc', 'blade', 'flattop', 'perfmesh'];

  function isExempt(b) {
    var s = String(b.category || '') + ' ' + String(b.item || '');
    return /delivery|pickup|inspection fee/i.test(s)
      || /installation|turn-key|labour|site inspection/i.test(s)
      || /^tax$/i.test(String(b.category || '').trim())
      || /\bgst\b/i.test(String(b.item || ''));
  }

  /* Still worth NOTICING - it tells the office which lines have no variant behind them
     and therefore will not be picked automatically. It is no longer a reason to refuse. */
  function unmatchedLines(q) {
    if (!q || !q.breakdown) return [];
    return q.breakdown.filter(function (b) {
      if (isExempt(b)) return false;
      if ((Number(b.quantity) || 0) <= 0) return false;
      return !b.variantId;
    });
  }

  function readQuote() {
    var pill = document.querySelector('.qr-quote-pill.is-active');
    var label = pill ? String(pill.textContent || '').trim() : '';
    if (!label) return null;
    for (var i = 0; i < CALCS.length; i++) {
      var c = CALCS[i], act = null;
      try { act = JSON.parse(localStorage.getItem(c + '_active_quote') || 'null'); } catch (e) {}
      if (act && act.breakdown && String(act.quoteName || '').trim() === label) return act;
      var arr = [];
      try { arr = JSON.parse(localStorage.getItem(c + '_quotes') || '[]') || []; } catch (e) {}
      for (var j = 0; j < arr.length; j++) {
        if (arr[j] && arr[j].breakdown && String(arr[j].quoteName || '').trim() === label) return arr[j];
      }
    }
    return null;
  }

  /* Anything a previous cached copy of this file may have left behind. Without this, a
     customer whose browser still holds the old asset keeps a greyed-out button. */
  function clearLegacyBlocking() {
    try {
      ['cf-ub-review', 'cf-ub-calc'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
      [].forEach.call(document.querySelectorAll('.cf-ub-blocked'), function (el) {
        el.classList.remove('cf-ub-blocked');
        el.style.removeProperty('pointer-events');
        el.style.removeProperty('opacity');
        el.style.removeProperty('filter');
      });
      var btn = document.getElementById('qr-enquire-btn');
      if (btn) {
        btn.classList.remove('cf-ub-blocked');
        btn.style.removeProperty('pointer-events');
        btn.style.removeProperty('opacity');
        btn.style.removeProperty('filter');
        if (btn.disabled) btn.disabled = false;
      }
      var css = document.getElementById('cf-ub-css');
      if (css && css.parentNode) css.parentNode.removeChild(css);
    } catch (e) {}
  }

  /* Put what we noticed on the cart so it lands on the order. Mirrors the interception in
     quote-review-si-addon.js - /cart/update.js is called once, with the customer's details,
     immediately before the redirect to /checkout. */
  function installCartFlag() {
    if (window.__cfUbCartHook) return;
    window.__cfUbCartHook = true;
    var origFetch = window.fetch;
    if (typeof origFetch !== 'function') return;

    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/update.js') !== -1 && init && typeof init.body === 'string') {
          var flagged = unmatchedLines(readQuote() || {});
          if (flagged.length) {
            var upd = JSON.parse(init.body);
            if (upd) {
              var list = flagged.map(function (b) { return b.quantity + ' x ' + b.item; }).join('; ');
              upd.attributes = upd.attributes || {};
              upd.attributes['Check With Customer'] = list;
              if (typeof upd.note === 'string') {
                upd.note += '\nCHECK BEFORE PICKING: no stock variant matched these lines - '
                  + list + '. Ring the customer if the design needs altering.\n';
              }
              init = Object.assign({}, init, { body: JSON.stringify(upd) });
              console.warn('[cf-unbuildable-guard] flagged for the office, checkout NOT blocked:', list);
            }
          }
        }
      } catch (e) {
        console.warn('[cf-unbuildable-guard] cart flag failed, order proceeds unflagged:', e);
      }
      return origFetch.call(this, input, init);
    };
  }

  var tries = 0;
  function tick() {
    if (tries++ > 60) return;
    clearLegacyBlocking();
    setTimeout(tick, 800);
  }

  installCartFlag();
  document.addEventListener('cf:quote-adjusted', function () { setTimeout(clearLegacyBlocking, 60); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
  else tick();

  console.log('[cf-unbuildable-guard] advisory only - never blocks checkout (2026-09-01)');
})();
